export default {
  getInforPos: state => state.pos,
  getIdPos: state => state.posId,
  getSavePos: state => state.posSave,
  loading: state => state.loading,
  params: state => state.params,
  itemPos: state => state.itemPos,
  modalAddCustomer: state => state.modalAddCustomer
};
